import React from 'react'

export const CircleUserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <title>Sirkel med brukerprofil</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M12 15a5.25 5.25 0 1 0 0-10.5A5.25 5.25 0 0 0 12 15"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M7.476 7.084A8.7 8.7 0 0 0 13.75 9.75a8.7 8.7 0 0 0 3.39-.685M5.087 20.876a9.745 9.745 0 0 1 13.805-.021"
    />
  </svg>
)
